// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2_Srn","colCheckbox":"styles_colCheckbox__OJs_S"};